const Dashboard = () => import('@/views/Dashboard/Dashboard/Dashboard.vue')

export default [
  {
    path: '/',
    component: Dashboard,
    name: 'Home'
  }
]
